import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getMeetEvaluationsByPersonIdData from './GetMeetEvaluationsByPersonIdData';
import postMeetEvaluationData from './PostMeetEvaluationData';
import putMeetEvaluationData from './PutMeetEvaluationData';
import deleteMeetEvaluationData from './DeleteMeetEvaluationData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const MeetEvaluationPersonData = {
  INITIAL_STATE, 
  getMeetEvaluationsByPersonIdData,
  postMeetEvaluationData,
  putMeetEvaluationData,
  deleteMeetEvaluationData
};

export default MeetEvaluationPersonData;